import { render, staticRenderFns } from "./BrightStoreTrackingBySalesArea.vue?vue&type=template&id=61055928&scoped=true"
import script from "./BrightStoreTrackingBySalesArea.vue?vue&type=script&lang=js"
export * from "./BrightStoreTrackingBySalesArea.vue?vue&type=script&lang=js"
import style0 from "./BrightStoreTrackingBySalesArea.vue?vue&type=style&index=0&id=61055928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61055928",
  null
  
)

export default component.exports